import { MainMenu } from 'rangeConfig/@types';
import platform from 'rangeConfig/shared/utils/platform';
import withProducts from 'rangeConfig/shared/widgets/withProducts';
import ProductList from 'rangeConfig/shared/widgets/ProductList';
import ProductSwiper from 'rangeConfig/shared/widgets/ProductSwiper';
import withCategoryFilter from 'rangeConfig/shared/widgets/withCategoryFilter';
import * as R from 'ramda';
import { default as White } from '../../ui/Colors/icons/white.js';
import { default as WhiteStainedOak } from '../../ui/Colors/icons/white_stained_oak.js';
import { default as RedBrown } from '../../ui/Colors/icons/red_brown.js';
import { default as LightGreen } from '../../ui/Colors/icons/light_green.js';
import { default as DarkGrey } from '../../ui/Colors/icons/dark_grey.js';
import { default as PalePink } from '../../ui/Colors/icons/pale_pink.js';
import { default as LightGrey } from '../../ui/Colors/icons/light_grey.js';
import { default as BrownWalnutEffect } from '../../ui/Colors/icons/brown_walnut_effect.js';
import { default as GreyGreen } from '../../ui/Colors/icons/grey_green.js';
import { default as LightGreyBlue } from '../../ui/Colors/icons/light_grey_blue.js';
import { default as PaleYellow } from '../../ui/Colors/icons/pale_yellow.js';
import { desktopProductListConfig, mobileProductListConfig } from './productListConfig';
import ChangeColorFilter from 'rangeConfig/shared/widgets/ChangeColorFilter/ChangeColorFilter.js';

const WhiteFramesSwiper = R.pipe(withCategoryFilter(['frameWhite']));
const WSOFramesSwiper = R.pipe(withCategoryFilter(['frameWSO']));
const BeigeFramesSwiper = R.pipe(withCategoryFilter(['frameBeige']));
const RBFramesSwiper = R.pipe(withCategoryFilter(['frameRB']));
const LGFramesSwiper = R.pipe(withCategoryFilter(['frameLG']));
const DGFramesSwiper = R.pipe(withCategoryFilter(['frameDG']));
const PinkFramesSwiper = R.pipe(withCategoryFilter(['framePINK']));
const LightGreyFramesSwiper = R.pipe(withCategoryFilter(['frameLightGrey']));
const BWEFramesSwiper = R.pipe(withCategoryFilter(['frameBWE']));
const WFramesSwiper = R.pipe(withCategoryFilter(['frameWood']));
const FMFramesSwiper = R.pipe(withCategoryFilter(['frameMetal']));
const GGFramesSwiper = R.pipe(withCategoryFilter(['frameGreyGreen']));
const LGBFramesSwiper = R.pipe(withCategoryFilter(['frameLightGreyBlue']));
const PYFramesSwiper = R.pipe(withCategoryFilter(['framePaleYellow']));

const widgets = {
  desktop: [
    {
      id: 'change-frame-color',
      component: ChangeColorFilter
    },
    {
      id: 'frames-product-list',
      component: withProducts(ProductList, desktopProductListConfig)
    }
  ],
  mobile: [
    {
      id: `frame-color-white`,
      component: WhiteFramesSwiper(withProducts(ProductSwiper, mobileProductListConfig)),
      title: 'storageone.colorWhite',
      icon: White,
      iconColor: '#FFFFFF'
    },
    {
      id: `frame-color-white-stained-oak-effect`,
      component: WSOFramesSwiper(withProducts(ProductSwiper, mobileProductListConfig)),
      title: 'storageone.colorWhiteStainedOak',
      icon: WhiteStainedOak,
      iconColor: '#CCB397'
    },
    {
      id: `frame-color-beige`,
      component: BeigeFramesSwiper(withProducts(ProductSwiper, mobileProductListConfig)),
      title: 'storageone.colorBeige'
    },
    {
      id: `frame-color-red-brown`,
      component: RBFramesSwiper(withProducts(ProductSwiper, mobileProductListConfig)),
      title: 'storageone.colorRedBrown',
      icon: RedBrown,
      iconColor: '#92462F'
    },
    {
      id: `frame-color-light-green`,
      component: LGFramesSwiper(withProducts(ProductSwiper, mobileProductListConfig)),
      title: 'storageone.colorLightGreen',
      icon: LightGreen,
      iconColor: '#A9AF99'
    },
    {
      id: `frame-color-dark-grey`,
      component: DGFramesSwiper(withProducts(ProductSwiper, mobileProductListConfig)),
      title: 'storageone.colorDarkGrey',
      icon: DarkGrey,
      iconColor: '#5D5551'
    },
    {
      id: `frame-color-pale-pink`,
      component: PinkFramesSwiper(withProducts(ProductSwiper, mobileProductListConfig)),
      title: 'storageone.colorPalePink',
      icon: PalePink,
      iconColor: '#EFD4C9'
    },
    {
      id: `frame-color-light-grey`,
      component: LightGreyFramesSwiper(withProducts(ProductSwiper, mobileProductListConfig)),
      title: 'storageone.colorLightGrey',
      icon: LightGrey,
      iconColor: '#C5C3BF'
    },
    {
      id: `frame-color-brown-walnut-effect`,
      component: BWEFramesSwiper(withProducts(ProductSwiper, mobileProductListConfig)),
      title: 'storageone.colorBrownWalnutEffect',
      icon: BrownWalnutEffect,
      iconColor: '#7E5942'
    },
    {
      id: `frame-color-wood`,
      component: WFramesSwiper(withProducts(ProductSwiper, mobileProductListConfig)),
      title: 'storageone.colorWood'
    },
    {
      id: `frame-color-metal`,
      component: FMFramesSwiper(withProducts(ProductSwiper, mobileProductListConfig)),
      title: 'storageone.colorMetal'
    },
    {
      id: `frame-color-grey-green`,
      component: GGFramesSwiper(withProducts(ProductSwiper, mobileProductListConfig)),
      title: 'storageone.colorGreyGreen',
      icon: GreyGreen,
      iconColor: '#4B4E40'
    },
    {
      id: `frame-color-light-grey-blue`,
      component: LGBFramesSwiper(withProducts(ProductSwiper, mobileProductListConfig)),
      title: 'storageone.colorLightGreyBlue',
      icon: LightGreyBlue,
      iconColor: '#BFC6CA'
    },
    {
      id: `frame-color-pale-yellow`,
      component: PYFramesSwiper(withProducts(ProductSwiper, mobileProductListConfig)),
      title: 'storageone.colorPaleYellow',
      icon: PaleYellow,
      iconColor: '#F5EFD2'
    }
  ]
};

const filters = {
  desktop: [],
  mobile: []
};

const mainMenu: MainMenu = {
  menuTitle: 'storageone.productListCabinetsTitle',
  behaviors: {
    productGroupEntered: [],
    productGroupExited: []
  },
  filters: filters[platform],
  widgets: widgets[platform]
};

export default mainMenu;
